import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageOpEdit
{
    save(button, opName)
    {
        if (!opName) return;
        const codeEle = ele.byId("code");
        if (!codeEle) return;

        const code = codeEle.value;
        const errorEle = ele.byId("errors");
        ele.hide(errorEle);

        web.buttons.startSavingAnimButton(button);
        api.put(
            "ops/" + opName,
            {
                "code": code
            },
            this._handleResponse,
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button, false, true);
                errorEle.innerText = "Error while saving: " + res.msg;
                ele.show(errorEle);
            }
        );
    }

    saveAttachment(button, opName, attName)
    {
        if (!opName) return;
        if (!attName) return;
        const codeEle = ele.byId(attName);
        if (!codeEle) return;
        const code = codeEle.value;
        const errorEle = ele.byId("errors");
        ele.hide(errorEle);

        web.buttons.startSavingAnimButton(button);
        api.post(
            "op/" + opName + "/attachment/" + attName,
            {
                "content": code
            },
            this._handleResponse,
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button, false, true);
                errorEle.innerText = "Error while saving: " + res.msg;
                ele.show(errorEle);
            }
        );
    }

    format(button, opName)
    {
        if (!opName) return;
        const codeEle = ele.byId("code");
        if (!codeEle) return;
        const code = codeEle.value;

        const errorEle = ele.byId("errors");
        ele.hide(errorEle);

        web.buttons.startSavingAnimButton(button);
        api.post(
            "ops/code/format",
            {
                "code": code,
            },
            (res) =>
            {
                this._handleResponse(res);
                if (!res.error)
                {
                    codeEle.value = res.opFullCode;
                }
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button, false, true);
                errorEle.innerText = "Error while saving: " + res.msg;
                ele.show(errorEle);
            }
        );
    }

    formatAttachment(button, opName, attName)
    {
        if (!opName) return;
        if (!attName) return;
        const codeEle = ele.byId(attName);
        if (!codeEle) return;
        const code = codeEle.value;
        const errorEle = ele.byId("errors");
        ele.hide(errorEle);

        web.buttons.startSavingAnimButton(button);
        api.post(
            "ops/code/format",
            {
                "code": code,
            },
            (res) =>
            {
                this._handleResponse(res);
                if (!res.error)
                {
                    codeEle.value = res.opFullCode;
                }
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button, false, true);
                errorEle.innerText = "Error while saving: " + res.msg;
                ele.show(errorEle);
            }
        );
    }

    formatJson(button)
    {
        const errorEle = ele.byId("errors");
        if (errorEle) ele.hide(errorEle);
        const textarea = ele.byId("json");
        if (!textarea) return;

        web.buttons.startSavingAnimButton(button);
        try
        {
            const json = JSON.parse(textarea.value);
            textarea.value = JSON.stringify(json, null, 4);
            web.buttons.stopSavingAnimButton(button);
            return true;
        }
        catch (e)
        {
            web.buttons.stopSavingAnimButton(button, false, true);
            console.error(e.message);
            if (errorEle)
            {
                errorEle.innerText = "Failed to format JSON: " + e.message;
                ele.show(errorEle);
            }
        }
        return false;
    }

    saveJson(button, opName)
    {
        const errorEle = ele.byId("errors");
        if (errorEle) ele.hide(errorEle);
        const textarea = ele.byId("json");
        if (!textarea) return;

        const valid = this.formatJson(button);
        if (valid)
        {
            const json = JSON.parse(textarea.value);
            web.buttons.startSavingAnimButton(button);
            api.post("op/json/" + opName, json, (res) =>
            {
                web.buttons.stopSavingAnimButton(button);
                if (res && res.data)
                {
                    textarea.value = JSON.stringify(res.data, null, 4);
                }
            }, (e) =>
            {
                web.buttons.stopSavingAnimButton(button, false, true);
                if (errorEle)
                {
                    errorEle.innerText = "Failed to save: " + e.msg;
                    ele.show(errorEle);
                }

            });
        }

    }

    _handleResponse(res)
    {
        web.buttons.stopSavingAnimButton(false, true, (res && res.error));
        const errorEle = ele.byId("errors");
        if (res && res.error)
        {
            errorEle.innerText = "Line " + res.error.line + " - " + res.error.message;
            ele.show(errorEle);
        }
    }
}
